
require.context('./imgs', true, /.*/); //copy whole imgs folder

import "./scss/styles.scss";

// import $ from 'jquery';
// import "bootstrap";
// import "nette.ajax.js";
// import "nette-forms";
import naja from 'naja';
import * as formValidators from "./js/formsValidation";
import "@fancyapps/fancybox/dist/jquery.fancybox";
import "justifiedGallery/src/js/justifiedGallery";
import "./js/components/antispam"
import {PaginationScrollExtension} from "./js/components/PaginationScrollExtension"


naja.initialize();
naja.registerExtension(new PaginationScrollExtension());
// import "../others/nette-ajax/spinner";
import "./js/cookiesConfirm"; //uncomment to use + set analytics

import "./js/components/slider";
import "./js/components/collapse";
import "./js/components/mainMenu";
import "./js/components/referencesSlider";

import "./js/payment";
import "./js/pricelist";
import "./js/tooltips";
import "./js/tarifOrder";
import "@/global/js/ares";
import "./js/inits";

// window.Nette = require('nette-forms');
// Nette.initOnLoad();
